import { Container, Stack } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Somaiya_small from "../Assets/Somaiya.svg";
import imd from "../Assets/imd.png";

function AboutHeader() {
  return (
    <Container className="Somaiya">
      <Card className="Somaiya_card">
        <Card.Body>
          <div>
            <Card.Subtitle className="Somaiya_name">
              Collaborative Research and Development by:
            </Card.Subtitle>
            <Stack direction="horizontal" gap={3} className="Dev_imd">
              <img alt="" src={imd} width="45px" className="imd_logo" />
              <Card.Subtitle className="Somaiya_name2">
                India Meteorological Department, Pune
              </Card.Subtitle>
            </Stack>
            <Stack direction="horizontal" gap={3}>
              <img
                className="Somaiya_logo"
                alt=""
                src={Somaiya_small}
                width="54px"
              />
              <Card.Subtitle className="Somaiya_name2">
                K. J. Somaiya Institute of Technology, Sion, Mumbai
              </Card.Subtitle>
            </Stack>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default AboutHeader;
